import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUdacityComponent } from './simple-icons-udacity.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUdacityComponent ],
    exports:      [ SimpleIconsUdacityComponent ],
    bootstrap:    []
})
export class SimpleIconsUdacityModule {}
